import React, { useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from "react-router-dom";

const RouteGuard = ({ children }) => {
  const {
    isLoading,
    isAuthenticated,
    error,
    loginWithRedirect,
  } = useAuth0();

  const location = useLocation();

  // Prevent multiple loginWithRedirect calls.
  const redirectingRef = useRef(false);

  useEffect(() => {
    if (!isLoading && !error && !isAuthenticated) {
      if (redirectingRef.current) {
        return;
      }

      redirectingRef.current = true;

      void loginWithRedirect({
        appState: {
          returnTo:
            location.pathname +
            location.search +
            location.hash,
        },
      }).catch((error) => {
        console.error("Login redirect failed:", error);
        redirectingRef.current = false;
      });
    }
  }, [
    isLoading,
    error,
    isAuthenticated,
    loginWithRedirect,
    location.pathname,
    location.search,
    location.hash,
  ]);

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-4">
            Authentication failed.
          </h2>

          <p className="mb-6">{error.message}</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="h-screen flex items-center justify-center">
        <p>Redirecting to login...</p>
      </div>
    );
  }

  return <>{children}</>;
};

export default RouteGuard;